import React from 'react';
import PropTypes from 'prop-types';

const TimetableBlock = props => {
  return (
    <div className="timetable-block mt-20px">
      <div className="timetable-header">
        <div className="is-flex align-items-center">
          <img src="img/icons/timetable.svg" />
          <span className="webinar-header-title ml-5px">My timetable</span>
        </div>
      </div>
      <div className="timetable-content">
        {/* <div className="is-flex justify-content-between align-items-end">
          <div>
            <p>The next lesson:</p>
            <p className="timetable-time-text">Date is undefined</p>
            11/11/2019 at 19:00
          </div>
          <a className="timetable-cancel-link">Cancel this lesson</a>
        </div> */}
        <div className="is-flex mt-20px">
          {props.timetable.map(item => (
            <div key={item.month} className="timetable-day">
              {item.month}
              {item.times.map((time, timeIndex) => (
                <div
                  key={timeIndex}
                  className="timetable-time"
                  style={{ left: 0, top: `${50 * (timeIndex + 1)}px`, width: '100%' }}
                >
                  <div className="is-flex justify-content-center align-items-center">
                    <div className="timetable-circle"></div>
                    <span className="ml-5px">{time}</span>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

TimetableBlock.propTypes = {
  timetable: PropTypes.arrayOf(
    PropTypes.shape({
      month: PropTypes.string.isRequired,
      times: PropTypes.arrayOf(PropTypes.string).isRequired,
    }),
  ).isRequired,
};

export default TimetableBlock;
